import React from 'react';
import { Episode } from '../../types/types';

interface EpisodeProps {
  episode: Episode;
}

const MobileEpisodeCard: React.FC<EpisodeProps> = ({ episode }) => {
  const { number, title, date, duration, thumbnailId, videoId } = episode;
  
  const handleClick = () => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  };
  
  return (
    <div className="mobile-episode-card" onClick={handleClick}>
      <div className="mobile-video-container">
        <img 
          src={`https://img.youtube.com/vi/${thumbnailId || videoId}/maxresdefault.jpg`}
          alt={`${title} Thumbnail`}
          loading="lazy"
          decoding="async"
          width="1280"
          height="720"
        />
      </div>
      <div className="mobile-episode-info">
        <span className="mobile-episode-number">{number}</span>
        <h3 className="mobile-episode-title">{title}</h3>
        <div className="mobile-episode-meta">
          <span>{date}</span>
          <span>{duration}</span>
        </div>
      </div>
    </div>
  );
};

export default MobileEpisodeCard; 